<template>
  <v-row align="center" class="ma-0 px-0 py-3">
    <v-col align="center" class="ma-0 pa-0" cols="12">
      <template v-if="!authorized">
        Du hast bereits ein Konto?

        <v-btn to="/"
               class="ml-3"
               id="sign-in-btn"
               style="border: none; background-color: transparent; box-shadow: none; font-weight: bold">
          Jetzt anmelden.
        </v-btn>
      </template>

      <template v-else>
        Du bist bereits eingeloggt.

        <v-btn @click="logOut"
               class="ml-5"
               id="sign-out-btn"
               style="border: none; background-color: transparent; box-shadow: none; font-weight: bold">
          Abmelden
        </v-btn>
      </template>
    </v-col>

  </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'fin-registration-footer',
  methods: {
    ...mapActions('auth', ['signOut']),
    logOut() {
      this.$router.push('/')
        .then(() => {
          this.signOut()
        })
        .catch(err => console.log('Error signing out from AWS', err))
    }
  },
  computed: mapState('auth', {
    authorized: state => state.authorized
  })
}
</script>

<style scoped>

</style>
